/**
 * Created by zhengyf on 2018/1/4.
 */

;(function () {

    ProductPostCtrl.$inject = ['request', '$scope', '$timeout', 'DataRecoverService', 'event'];
    angular.module('DSSXAPP', ['app.core']);

    angular
        .module('DSSXAPP')
        .controller('ProductPostCtrl', ProductPostCtrl);

    function ProductPostCtrl(request, $scope, $timeout, DataRecoverService, event) {

        var vm = this;
        var util = DSSX.util;
        var store = {
            productId: util.queryString('productId'),
            copyId: util.queryString('copyId'),
            sketch: null
        };

        vm.c = {
            loadStatus: '', // success failed
            showExportView: false,
            marketId: 'EN',
        };

        vm.d = {
            category: null,
            directOrder: '', // 产品类型
            langMarket: 'EN', // 语言市场
            step: '',
            form: null,
            title: '发布产品'
        };

        vm.f = {
            getCategory: getCategory,
            reSelect: reSelect,
            modifyFormTitle: modifyFormTitle,
            switchPageLayout: switchPageLayout,
            closeSketchTip: closeSketchTip,
            recoverSketch: recoverSketch,
            closeTipAndLoadProd: closeTipAndLoadProd,
            changeMarket: changeMarket
        };

        vm.getForm = null;

        init();

        function init() {
            console.log('[product-post.js ProductPostCtrl init: ]');
            initEvent();

            // 如果是发布类似产品，则复制相应ID的产品的信息更新到发布页面，无需恢复底稿
            if(store.copyId) {
                loadProductInfo(store.copyId, 'copy');
            }
            else {
                // 是否提示恢复数据
                showRecoverDataTip()
                    .then(function (isShow) {
                        if (!isShow) {
                            store.productId ? loadProductInfo(store.productId) : updatePageStatus('one');
                        } else {
                            openLayerTip();
                        }
                    });
            }

            $timeout(function () {
                initTips();
            });
        }

        //发布产品提交第一步时，获取select-cate中的分类和产品类型，以便传进第二步中
        function getCategory(event) {
            vm.d.category = event.path;
            vm.d.directOrder = event.directOrder;
            vm.d.step = 'two';
            closeSketchTip();
        }

        //切换类目和产品类型时，获取product-form中的分类、产品类型和语言市场，回填到第一步中
        function reSelect(event) {
            vm.d.step = 'one';
            vm.d.category = event.path;
            vm.d.directOrder = event.directOrder;
            vm.d.langMarket = event.langMarket;
        }

        function modifyFormTitle() {
            vm.d.title = '修改产品';
        }

        function switchPageLayout() {
            vm.d.step = 'three';
        }

        // 加载产品信息
        function loadProductInfo(pid, action) {

            var url = '/usr/api/loadMyPrd';
            var _params = {
                productId: pid
            };

            if (pid === util.safe(DSSX, 'currUser.firstProdId', '')) {
                //是第一次发布的产品
                _params.isFirst = 'yes';
            }

            request.get(url, _params, true).then(callback, function (err) {

                var code = util.safe(err, 'data.data.code', -1);

                if (code === 4 || code === 5) {
                    vm.c.loadStatus = 'failed';
                    return;
                }

                DSSX.dialog.err(err, {
                    moduleName: '产品编辑',
                    funcName: 'loadProductInfo',
                    text: '加载产品信息失败'
                });
            });

            function callback(res) {
                updatePageStatus('two');
                vm.d.form = util.safe(res, 'data.product', {});
                // 前后端返回的"商品详情"的数据格式有差异，前端需要一个对象，后端返回的是数组
                var formBuffer = util.safe(res, 'data.product', {});
                var detailDescs = formBuffer.detailDesc;
                var decsObject = {items:[],preview:''};
                detailDescs.forEach(function(element) {
                  if(element.Key === 'items' && element.Value !== null){
                     decsObject.items = element.Value;
                  }
                  if(element.Key === 'preview'){
                     decsObject.preview = element.Value;
                  }
                });
                vm.d.form.detailDesc = decsObject;
                vm.d.form = correctOldData(vm.d.form);
                
                // 发布类似产品属于新增，状态改为草稿状态
                if(action === 'copy') {
                    vm.d.form.status = 'draft';
                }
            }
        }

        function initEvent() {
            $scope.$watch('vm.d.step', function (newVal) {
                if (newVal === 'two') {
                    $timeout(function () {

                        store.sketch = store.sketch || {};
                        var id = store.sketch.id || store.productId;
                        // 启动底稿功能
                        var options = {
                            ls: {
                                isShareSketch: false,
                                time: 5000
                            },
                            server: {
                                time: {
                                    first: 5000,
                                    normal: 20000
                                }
                            }
                        };
                        DataRecoverService.start('Product', vm.getForm, id, options);
                    });
                }
            });

            event.on('product-post-change-export-view', function (value) {
                vm.c.showExportView = value.showExportView;
            });
        }

        // 获取最新的底稿数据
        function getLastSketchData() {
            return DataRecoverService.getLastSketch('Product', store.productId);
        }

        // 显示恢复数据提示
        function showRecoverDataTip() {
            return getLastSketchData()
                .then(function (sketch) {
                    store.sketch = sketch;
                    return !!store.sketch;
                });
        }

        // 关闭数据恢复提示 // 新增产品
        function closeSketchTip() {
            store.sketch = {};
        }

        // 恢复底稿数据
        function recoverSketch() {
            store.sketch.data.data = correctOldData(store.sketch.data.data);
            vm.d.form = store.sketch.data.data;
            DataRecoverService.updateSketch(store.sketch);
            event.emit('getEditorContent');
            updatePageStatus('two');
        }

        // 关闭恢复数据提示并加载原始服务器数据
        function closeTipAndLoadProd() {
            loadProductInfo(store.productId);
        }

        // 更改页面状态
        function updatePageStatus(step) {
            vm.d.step = step;
            vm.c.loadStatus = 'success';
        }

        function openLayerTip() {
            updatePageStatus('one');
            // $timeout(function () {
            //     recoverSketch();
            // });
            // return;
            layer.open({
                type: 1,
                title: '提示',
                content: '<p style="margin: 0;padding: 20px 20px 0;font-size: 12px;">系统已为您保存上次未编辑完成的信息</p><p style="margin:0;padding: 10px 20px 0;color: #ccc;font-size: 12px;">如果想不再提示，请选择丢弃</p>',
                area: ['300px', '175px'],
                btn: ['恢复', '取消', '丢弃，不再提示'],
                yes: function (index) {
                    $timeout(function () {
                        recoverSketch();
                        layer.close(index);
                    })
                },
                btn2: function (index) {
                    cancel(index);
                },
                btn3: function (index) {
                    // 丢弃底稿
                    DataRecoverService.deleteSketch('Product', store.sketch.id)
                        .then(function () {
                            cancel(index);
                        }, function (error) {
                            DSSX.dialog.err(error);
                        });
                    return false;
                },
                cancel: function (index) {
                    cancel(index);
                }
            });

            function cancel(index) {
                $timeout(function () {
                    store.productId ? closeTipAndLoadProd() : closeSketchTip();
                    layer.close(index);
                })
            }

            // 修改丢弃底稿按钮的样式
            $('#layui-layer1').find('.layui-layer-btn').find('.layui-layer-btn2').css({
                position: 'absolute',
                left: '15px',
                background: 'transparent',
                border: 'none',
                color: '#999',
                padding: '0'
            })
        }

        function initTips() {
            showTip("#product-export-info", "#product-export-info", "非“一拍档”的第三方服务商不得编辑操作产品出口信息", 1);
            showTip("#association-certificate-help", "#association-certificate-help", "验真通过标准（以下两条标准必须同时符合才能验真通过，否则则验真不通过）：<br>" +
                "1、证书必须真实存在（认证机构数据库中能查询到该认证信息）<br>" +
                "2、证书持有人与当前阿里巴巴平台注册公司名必须一致 <br>" +
                "注：产品证书关联到产品，即为确认授权该证书出具机构等向阿里巴巴提供该证书对应的产品检测认证数据，包括公司名、证书号、地址、类型、检测标准、产品名称、规格参数、证书有效期等并加以展示（如为非自身产品，确认已获取产品方同意可作出前述授权确认）。如无法确认，请勿填写", 2);
        }

        function showTip(target, anchor, msg, position) {
            var id;
            $(target).hover(function () {
                id = layer.tips('<span style="color: #333333;">' + msg + '</span>', anchor, {
                    tips: [position, '#ffffff'],
                    time: 2000000
                });
            }, function () {
                layer.close(id);
            });
        }

        function changeMarket() {
            $timeout(function () {
                location.href = vm.c.marketId === 'EN' ? 'product-post.html' : ('multi-lang-product-post.html?market=' + vm.c.marketId);
            });
        }

        // 要对旧版本的产品信息作兼容处理
        function correctOldData(oldData) {
            var newData = angular.copy(oldData);

            // 初始化物流信息对象进行兼容，旧数据会返回空
            if(!newData.logisticsInfo) {
                newData.logisticsInfo = {
                    feightTmpl: {
                        id: '',
                    },
                    grossWeightPerProduct: '',
                    logisticsModel: '',
                    sizePerProduct: {
                        height: {
                            unit: 'CM',
                            value: '',
                        },
                        length: {
                            unit: 'CM',
                            value: '',
                        },
                        width: {
                            unit: 'CM',
                            value: '',
                        },
                    }
                };
            }
            
            // 兼容语言市场
            if(!newData.langMarket) {
                newData.langMarket = 'EN';
            }
            // 兼容评分
            if(!newData.score) {
                newData.score = -1;
            }

            console.log('[product-post.js correctOldData] correct old data finish!');
            return newData;
        }
    }

})();
